import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import { QueueInfo } from '~/interfaces';
import log from '~/helpers/log';
import api from '~/services';

import GenericSelect from '../GenericSelect';

import { MenuItem, ListItemText } from '../sharedStyles';

export default function QueueSelector() {
  const filterName = 'Queues';

  const [queueList, setQueueList] = useState<QueueInfo[]>([]);

  const selectedQueues = useSelector(
    (state: RootStateOrAny) => state.historyFilterOptions.queues
  );

  const getAllQueues = useCallback(async () => {
    try {
      const data: QueueInfo[] = (await api.queues.get.allQueues())?.data;
      setQueueList(data);
    } catch (err) {
      log.error('Failed to fetch all queues.', err);
    }
    return [];
  }, []);

  useEffect(() => {
    if (selectedQueues?.length === 0) getAllQueues();
  }, [selectedQueues, getAllQueues]);

  const renderValue = (values: string[]) => {
    const [valueOne] = values;

    if (Array.isArray(values) && valueOne !== filterName && queueList) {
      const associatedNames = values.map(queueNumber => {
        const queueInfo = queueList.find(q => q.number === queueNumber);
        return queueInfo && queueInfo.name ? queueInfo.name : queueNumber;
      });

      return `Q: ${associatedNames.filter(name => name).join(', ')}`;
    }

    return values;
  };

  return (
    <GenericSelect
      filterName={filterName}
      dataSelected={selectedQueues}
      renderValue={renderValue}
      disabled={!queueList?.length}>
      {queueList?.length &&
        queueList.map(queue => (
          <MenuItem key={queue.number} value={queue.number}>
            <Checkbox checked={selectedQueues.indexOf(queue.number) > -1} />
            <ListItemText>
              Q: <b>{queue.number}</b> {queue.name}
            </ListItemText>
          </MenuItem>
        ))}
    </GenericSelect>
  );
}
